import React, {PureComponent, Fragment} from 'react';
import EncodingSelector from '../EncodingSelector';
import DelimiterSelector from '../DelimiterSelector';
import $ from 'jquery';
import Cookie from 'js-cookie';

const defaultState = {
	encoding: 'UTF-8',
	delimiter: ';',
	import_file: null,
	state: 'setup',
	process_data: {
		processId: null,
		offset: 0,
		size: Infinity
	}
};

export default class ImportPvz extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {...defaultState};
	}

	render() {
		const context = this.props.context

		return (
			<Fragment>
				{this.state.state === 'setup' && (
					<Fragment>
							<div className="field">
								<div className="name">
									Кодировка
								</div>
								<div className="value">
									<EncodingSelector
										context={context}
										value={this.state.encoding}
										onChange={e => {
										this.setState({
											encoding: e.target.value
										});
									}} />
								</div>
							</div>
							<div className="field">
								<div className="name">
									Разделитель данных
								</div>
								<div className="value">
									<DelimiterSelector
										context={context}
										value={this.state.delimiter}
										onChange={e => {
										this.setState({
											delimiter: e.target.value
										});
									}} />
								</div>
							</div>
							<div className="field">
								<div className="name">
									Файл
								</div>
								<div className="value">
									<input type="file" onChange={e => {
										this.setState({
											import_file: e.target.files
										});
									}} accept=".csv" />
								</div>
							</div>
							<div className="field">
								<div className="value submit">
									<button className="button green" onClick={() => {
										if (!this.state.import_file || this.state.import_file.length === 0) {
											return;
										}

										this.setImportState('process');
										this.runImport();
									}}>
										Запустить
									</button>
								</div>
							</div>
					</Fragment>
				)}

				{this.state.state === 'process' && (
					<Fragment>
						<div className="progressbar blue">
							<div className="progressbar-outer">
								<div className="progressbar-inner" style={{
									width: `${(this.state.process_data.offset / this.state.process_data.size)
									* 100}%`
								}} />
							</div>
						</div>

						{
							this.state.process_data.size !== Infinity ? (
								<Fragment>
									Обработано байт: {this.state.process_data.offset} / {this.state.process_data.size}
								</Fragment>
							) : (
								<Fragment>
									Подготовка...
								</Fragment>
							)
						}
					</Fragment>
				)}

				{this.state.state === 'done' && (
					<Fragment>
							<div className="field">
								Импорт выполнен успешно
							</div>
							<div className="field">
								<button className="button green" onClick={() => {
									this.setState(defaultState);
									this.setImportState('setup');
								}}>
									Новый импорт
								</button>
							</div>
					</Fragment>
				)}
				<div className="clear" />
			</Fragment>
		);
	}

	setImportState = (state) => {
		const {onChangeState} = this.props;

		this.setState({
			state: state,
		});

		onChangeState(state);
	};

	step_interval_id = null;

	runImport = () => {
		const data = new FormData();
		data.append('encoding', this.state.encoding);
		data.append('delimiter', this.state.delimiter);
		data.append('_csrf', Cookie.get('_csrf'));
		data.append('import_file', this.state.import_file[0]);

		$.ajax({
			url: '?plugin=pokupki&action=importPvz',
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: data,
			dataType: 'json'
		}).then(response => {
			this.setState({
				process_data: response
			});

			this.step_interval_id = setInterval(this.stepImport, 1000);
		});
	};

	count_step_requests = 0;

	stepImport = () => {
		if (this.count_step_requests >= 2) {
			return;
		}

		$.ajax({
			url: '?plugin=pokupki&action=importPvz',
			cache: false,
			data: {
				processId: this.state.process_data.processId
			},
			dataType: 'json'
		}).then(response => {
			this.count_step_requests--;

			if (response.ready) {
				this.doneImport();
				return;
			}

			this.setState({
				process_data: response
			});
		}, () => {
			this.count_step_requests--;
		});

		this.count_step_requests++;
	};

	doneImport = () => {
		clearInterval(this.step_interval_id);

		this.setImportState('done');
	};
}